import ModalTitle, { ModalTitleProps } from './ModalTitle';

export default ModalTitle;
export type { ModalTitleProps };
